<!--
 * @Author: Gaho
 * @Date: 2024-06-19 10:20:08
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-29 16:21:17
 * @Description: 
-->
<template>
    <q-dialog
        class="game-dialog z-[111]"
        full-width
        full-height
        :position="'top'"
        @hide="handleHide"
        style="background:#1c2532;"
        :transition-show="'slide-left'"
        :transition-hide="'slide-right'"
        :transition-duration="300"
        :model-value="show"
    >
        <div class="game-history">
            <!-- Select 区域 -->
            <div class="history-select">
                <div class="flex flex-nowrap gap-[8px]">
                    <ClientOnly>
                        <DropDown
                            class="drop-down"
                            v-model="gameCategoryValue"
                            :options="gameCategoryOptions"
                            @update:model-value="(value) => handleSelectGame(value, 'category')"
                        />
                    </ClientOnly>
                    <DropDown
                        class="drop-down"
                        v-if="gameDropOptions.length > 0 && gameCategoryValue === 'dapps'"
                        v-model="gameDropValue"
                        :options="gameDropOptions"
                        showOptionIcon
                        @update:model-value="(value) => handleSelectGame(value, 'game')"
                    >
                        <template #prevIcon>
                            <img v-if="getGameIcon(gameDropValue)?.src"
                                :src="getGameIcon(gameDropValue)?.src"
                                :class="sGameIconClass"
                            />
                            <IconSvgUse v-else
                                :use="`icon-${gameDropValue}`"
                                class="w-[20px] text-[#93ACD3FF] h-[20px]"
                            />
                        </template>
                    </DropDown>
                </div>
                <q-btn class="popup-close" icon="close" color="white" flat round dense v-close-popup />
            </div>
            <!-- ↑ 选项区 -->
            <!-- ↓ Table 区域 -->
            <div class="table-container"
                v-if="hasHistoryData"
            >
                <div class="history-table"
                    v-if="!sSpecialGameName"
                >
                    <div class="table-header flex items-center">
                        <span v-for="item in columns"
                            :key="item.field"
                            class="inline-block text-[#55657e] font-bold text-[11px] pl-[16px] cursor-pointer relative header-th truncate"
                            :style="`max-width: ${item?.maxWidth};min-width: ${item?.minWidth}`"
                            :class="`item-${item.field}`">
                            {{ item.label }}
                        </span>
                    </div>
                    <div class="table-body">
                        <ul>
                            <li v-for="item in historyData?.response" :key="item._id"
                                @click="() => handleOpenModalClick(item)">
                                <div :style="`max-width: ${columns[0]?.maxWidth};min-width: ${columns[0]?.minWidth};width: ${columns[0]?.minWidth}`"
                                    class="text-[#93acd3] text-[12px] font-semibold cursor-pointer flex items-center gap-[6px] flex-nowrap"
                                    :class="`item-${columns[0].field}`">
                                    <p class="flex flex-col flex-nowrap truncate">
                                        <span class="text-[12px] text-white truncate">
                                            {{
                                                moment(item.timestamp).format(
                                                    localeLang === 'cn'
                                                    ? 'YYYY/MM/DD'
                                                    : 'DD/MM/YYYY'
                                                )
                                            }}
                                        </span>
                                        <span class="text-[11px] text-[#93acd3] truncate">
                                            {{ localeLang === 'cn' ? moment(item.timestamp).format('HH:mm:ss') :
                                                moment(item.timestamp).format('hh:mm:ss A') }}
                                        </span>
                                    </p>
                                </div>
                                <div :style="`max-width: ${columns[1]?.maxWidth};min-width: ${columns[1]?.minWidth};width: ${columns[1]?.minWidth}`"
                                    class="text-[#93acd3] text-[14px] font-semibold cursor-pointer"
                                    :class="`item-${columns[1].field}`">
                                    {{ gameName }}
                                </div>
                                <div :style="`max-width: ${columns[2]?.maxWidth};min-width: ${columns[2]?.minWidth};width: ${columns[2]?.minWidth}`"
                                    class="pl-[8px] flex text-[14px] flex-nowrap" :class="`item-${columns[2].field}`">
                                    <CurrentCoin :name="item.currency" size="18px" class="mr-[.25em]" />
                                    <CasinoWidgetColoredAmount class="font-semibold truncate"
                                        :colors="[item.winAmount ? '#1BB83D' : '#fff', 'rgb(85,101,126)']"
                                        :amount="item.amount">
                                    </CasinoWidgetColoredAmount>
                                </div>
                                <div :style="`max-width: ${columns[3]?.maxWidth};min-width: ${columns[3]?.minWidth};width: ${columns[3]?.minWidth};`"
                                    class="pl-[8px]" :class="`item-${columns[3].field}`">
                                    <CasinoWidgetColoredAmount class="font-semibold truncate"
                                        :colors="[item.winAmount ? '#1BB83D' : '#fff', 'rgb(85,101,126)']"
                                        :amount="Number(getFixed(item.multi))"></CasinoWidgetColoredAmount>
                                </div>
                                <div :style="`max-width: ${columns[4]?.maxWidth};min-width: ${columns[4]?.minWidth};width: ${columns[4]?.minWidth}`"
                                    class="px-[8px] flex justify-between text-[14px]"
                                    :class="`item-${columns[4].field}`">
                                    <p class="flex text-[14px] max-w-[100%] flex-nowrap">
                                        <CurrentCoin :name="item.currency" size="18px" class="mr-[.25em]" />
                                        <CasinoWidgetColoredAmount class="font-semibold truncate"
                                            :colors="[item.winAmount ? '#1BB83D' : '#fff', 'rgb(85,101,126)']"
                                            :amount="Number(getFixed(item.winAmount))"></CasinoWidgetColoredAmount>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--
                    ↑ 通用游戏 
                    ↓ Futures 游戏 Table 区域 
                -->
                <div v-else-if="sSpecialGameName == 'futures'"
                    class="flex relative flex-col gap-2 w-full">
                    <!-- 列表头，伪 theader -->
                    <!-- ↓ 这个元素的的一个类名被拿走了 “gap-2” 因为造成了表头与列无法对齐，且原站点也没有 gap 值 -->
                    <div class="w-full flex flex-nowrap px-2 py-2 text-[11px] font-bold text-[#55657E] justify-around">
                        <HeadersWavesClosed :isMobileMode="isMobileMode"></HeadersWavesClosed>
                    </div>
                    <!-- 列表，伪 tbody -->
                    <div class="gap-2 flex w-full">
                        <!-- ↓ 表格行组件外套 -->
                        <div class="w-full flex-nowrap font-semibold flex rounded-md min-h-[50px] items-center bg-[rgba(22,31,44,.8)] px-2 py-2 text-[#93ACD3] justify-around"
                            v-for="(history, idx) in historyData?.response"
                            :key="history._id"
                            :test-mark="history?._id || `No ID ${idx}`"
                        >
                            <!-- ↓ 表格的小单元格 -->
                            <BodysWavesClosed
                                @openGameDetail="openGameDetail"
                                :isMobileMode="isMobileMode"
                                :key="history._id"
                                v-bind:history="history"
                            >
                            </BodysWavesClosed>
                        </div>
                    </div>
                </div>
                <!-- 
                    ↑ futures
                    ↓ redpacket
                -->
                <div v-else-if="sSpecialGameName == 'redpacket'"
                    classsss="flex relative flex-col gap-2 w-full"
                    class="pb-5"
                >
                    <RedpacketHistoryList 
                        :forHistoryPage="true" 
                    />
                </div>
                <!-- ↓ zhajinhua -->
                <div v-else-if="sSpecialGameName == 'zhajinhua'"
                    classsss="flex relative flex-col gap-2 w-full"
                    class="pb-5"
                >
                    <GoldenflowerHistoryList  :forHistoryPage="true"  />
                </div>
                <!-- ↑ zhajinhua -->
                <!-- ↓ niuniu -->
                <div v-else-if="sSpecialGameName == 'niuniu'"
                    classsss="flex relative flex-col gap-2 w-full"
                    class="pb-5"
                >
                    <NiuniuHistoryList :forHistoryPage="true"/>
                </div>
                <!-- ↑ niuniu -->
                <!--
                    ↑ 游戏历史表格
                    ↓ Pagination 区域
                -->
                <div class="history-pagination"
                    v-if="isShowPagination"
                >
                    <q-pagination
                        v-model="params.page"
                        :max="Math.ceil(historyData?.count / 50)"
                        :max-pages="4"
                        boundary-numbers
                        color="[#55657e]"
                        active-color="[#2281f6]"
                        direction-links
                    />
                </div>
            </div>

            <div class="pt-[79px]" v-else>
                <Empty >
                    <img width="134" height="132" src="@/assets/imgs/casino/no-data-image.webp" />
                </Empty>
            </div>
        </div>
    </q-dialog>
    <!-- ↓ 以下是各个窗口 -->
    <!-- ↓ 游戏历史窗口 -->
    <CasinoHistoryModalGameDetali
        :gameDropValue="gameDropValue"
        :historyDetail="historyDetail"
        @hideModel="hideModel"
        @handlePrinciple="handlePrinciple"
    />
    <ModalMobilePrinciple
        :model-value="principleVisible"
        @update:model-value="handlePrinciple"
    />
</template>

<script lang="ts">
import moment from 'moment';
import HeadersWavesClosed from '~/components/Casino/History/Headers/WavesClosed.vue';
import BodysWavesClosed from '~/components/Casino/History/Bodys/WavesClosed.vue';
import RedpacketHistoryList from '@/pages/casino/redpacketGame/_components/historyList.vue'; 
import GoldenflowerHistoryList from '~/pages/casino/zhajinhuaGame/_components/historyList.vue'; 
import NiuniuHistoryList from '@/pages/casino/niuniuGame/_components/historyList.vue'

// stores & socket
import { useGameIdListStore } from '@/stores/cansino/gameIdList';
import { useGameHistorySocket } from '@/socket/gamehistory';
import useGlobalStore from '@/stores/global';
// functions
import useTranslation from '@/i18n/useTransLation';
import { winAmount, setAmountZero } from '@/pages/casino/plinkoGame/utils/index';
import { getInfo4Rows } from '@/pages/casino/futuresGame/ts/wavesFn';
import { fnSettingCenter_Ft } from '@/pages/casino/futuresGame/ts/wavesControlCenter';
import { useRedPacket } from '@/socket/game/redpacket'; 
// assets
import futuresIcon from '@/assets/svg/icon-futures.svg';
import niuniuIcon from '@/assets/svg/icon-niuniu.svg';
import goldenFlowerIcon from '@/assets/svg/icon-goldenFlower.svg';
import redpacketIcon from '@/assets/svg/icon-redpacket.svg';
import { getGameName } from '@/common/js/gameAbout';


export default defineComponent({
    name: 'GameHistory',
    components: {
        HeadersWavesClosed,
        BodysWavesClosed,
        RedpacketHistoryList,
        GoldenflowerHistoryList,
        NiuniuHistoryList
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const t = useTranslation();
        return {
            sGameIconClass: "w-[20px] text-[#93ACD3FF] h-[20px] p-[3px]",
            historyDetailShow: false,
            historyDetail: {},
            gameIdListStore: useGameIdListStore(),
            globalStore: useGlobalStore(),
            gameDropOptions: [], // 游戏列表数据
            gameCategoryOptions: [
                { // 游戏目录数据
                    value: 'dapps',
                    name: t['BetCorgiOriginals'],
                },
                // { // 暂时注释，接口没有根据category返回数据 
                //     value: 'futures',
                //     name: t['Futures'],
                // }, 
            ],
            gameCategoryValue: 'dapps', // 当前选中的游戏目录
            gameDropValue: '', // 当前选中的游戏
            params: {
                page: 1, // 页码
                category: '',
                game: ''
            },
            historyData: { // 表格历史数据
                response: [],
                count: 0,
            },
            t,
            moment: moment,
            principleVisible: false,
            columns: [ {
                name: t.Time,
                label: t.Time,
                field: 'timestamp',
                maxWidth: '25%',
                minWidth: '25%',
            }, {
                name: t.Game.toUpperCase(),
                label: t.Game.toUpperCase(),
                field: 'game',
                maxWidth: '30%',
                minWidth: '30%',
            }, {
                name: t.BetAmount.toUpperCase(),
                label: t.BetAmount.toUpperCase(),
                field: 'amount',
                maxWidth: '27.5%',
                minWidth: '27.5%',
            }, {
                name: t.Multiplier.toUpperCase(),
                label: t.Multiplier.toUpperCase(),
                field: 'multi',
                maxWidth: '20%',
                minWidth: '20%',
            }, {
                name: t.winningAmount.toUpperCase(),
                label: t.winningAmount.toUpperCase(),
                field: 'winAmount',
                maxWidth: '27.5%',
                minWidth: '27.5%',
            } ],
        };
    },
    computed: {
        gameName() {
            const oGame = this.gameDropOptions.find(game => {
                return game.value === this.gameDropValue;
            });
            return oGame?.name;
        },
        sSpecialGameName(){
            // ↓ 一些游戏无法使用通用的游戏表格 
            const aSpecial = [
                'futures',
                'redpacket',
                'niuniu',
                'zhajinhua',
                'jisuzhajinhua'
                // 'xxxx',// 逐个添加 
            ];
            if (aSpecial.includes(this.gameDropValue)){
                return this.gameDropValue;
            }
            return ''; 
        },
        hasHistoryData(){
            const aGames = [
                'redpacket',
                'niuniu',
                'zhajinhua',
                'jisuzhajinhua'
            ];
            if (aGames.includes(this.gameDropValue)){
                // 这几个游戏时不要显示“无数据页” 
                // 即使真的无数据，也由这些游戏内部的历史记录组件来显示无数据提示
                return true;
            }
            return this.historyData?.response?.length > 0;
        },
        isShowPagination(){
            if (this.gameDropValue == 'redpacket'){
                return false; // 假设有数据 
            }
            return this.historyData?.response?.length > 0;
        },
        localeLang() {
            return useI18n().locale.value;
        },
        isMobileMode() {
            const { theme } = useRuntimeConfig().public.tailwind;
            const { max } = theme.extend.screensInt.sm;
            return this.globalStore.innerWidth <= max;
        },
    },
    watch: {
        params: {
            handler(newVal, oldVal) {
                if (!newVal) return;
                this.handleEmitGetHistory(newVal); 
            },
            deep: true,
        },
        'gameIdListStore.gameIdList': {
            handler(aNewVal) {
                const isReady = import.meta.client && aNewVal?.length;
                if (!isReady || this.gameDropOptions.length) {
                    return;
                }
                this.initData();
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        
    },
    methods: {
        winAmount,
        setAmountZero,
        getGameIcon(sGame){
            const oGameIconsSrc = {
                futures: {
                    src: futuresIcon,
                    img: `<img src="${futuresIcon}" class="${this.sGameIconClass}" />`, 
                },
                redpacket: {
                    src: redpacketIcon,
                    img: `<img src="${redpacketIcon}" class="${this.sGameIconClass}" />`, 
                },
                niuniu: {
                    src: niuniuIcon,
                    img: `<img src="${niuniuIcon}" class="${this.sGameIconClass}" />`, 
                },
                zhajinhua:{
                    src: goldenFlowerIcon,
                    img: `<img src="${goldenFlowerIcon}" class="${this.sGameIconClass}" />`,  
                }
            };
            return oGameIconsSrc[sGame];
        },
        /**
         * 数据初始化
         */
        initData() {
            const arr01 = this.gameIdListStore.gameIdList;
            // console.log('arr01', deepCopy(arr01)); 
            this.gameDropOptions = arr01.map(item => {
                return {
                    ...item,
                    value: item.name,
                    name: this.t[item.title],
                    optionIcon: this.getGameIcon(item.name)?.img || null,
                };
            });
            // console.log('gameHistory', deepCopy(this.gameIdListStore.gameIdList));
            this.gameCategoryValue = 'dapps';
            this.gameDropValue = this.getCurrentGame();
            const gameId = this.gameDropOptions.find(game => {
                return game.value === this.gameDropValue;
            })?.id || '';
            // ↓ watch 在监听此项，赋值时会触发查询  
            this.params = {
                ...this.params,
                category: this.gameCategoryValue,
                game: gameId.toString(),
            }
        },
        /**
         * 查询特定游戏历史数据，此方法通过 watch 触发 
         * @param params 请求参数
         */
        async handleEmitGetHistory(params) {
            const sSearchFor = `游戏历史：${this.gameDropValue} 查询中↓\n`;
            // ↓ 先清空旧的数据  
            this.historyData.response.splice(0, Infinity);
            const isFutures = this.gameDropValue === 'futures';
            if (isFutures) {
                const { fetchSettingsIfNeed } = fnSettingCenter_Ft();
                // ↓ 说明：下方的 getInfo4Rows() 依赖此方法的预先执行 
                await fetchSettingsIfNeed();
            }else if (this.gameDropValue == 'redpacket'){
                this.getRedpacketHistory(params);
                return; 
            }else if (this.gameDropValue == 'niuniu'){
                // this.xxxx(); 
                return; 
            } else if(this.gameDropValue == 'zhajinhua') {
                return; 
            }
            const { EMIT_GET_HISTORY } = useGameHistorySocket();
            EMIT_GET_HISTORY(params, (res) => {
                console.log(sSearchFor, res);
                if (!res || res?.['error']) return;
                // futures游戏数据
                if (isFutures) {
                    res.response ||= [];
                    res.response = res.response.map((item: any) => {
                        const current = {
                            ...item,
                            ...getInfo4Rows(item),
                        };
                        return current;
                    });
                }
                Object.assign(this.historyData, res);
            });
        },
        /**
         * 查询红包游戏历史 
         */
        async getRedpacketHistory(params){

        },
        /**
         * 切换游戏查询history
         * @param value 游戏、分类
         * @param type game-游戏 category-分类
         */
        handleSelectGame(value, type) {
            console.log(value, type);
            this.params.page = 1;
            if (type === 'game') {
                const gameId = this.gameDropOptions.find(game => game.value === value).id;
                this.params = {
                    ...this.params,
                    category: this.gameCategoryValue,
                    game: gameId.toString(),
                }
            } else {
                const gameId = this.gameDropOptions.find(game => {
                    return game.value === this.gameDropValue; 
                }).id;
                this.params = {
                    ...this.params,
                    category: value,
                    game: gameId.toString(),
                }
            }
        },
        /**
         * 打开下注详情弹框
         * @param item 
         */
        handleOpenModalClick(item) {
            // const router = useRouter();
            // const route = useRoute();
            // router.push({
            //     replace: true,
            //     path: route.path,
            //     query: {
            //         ...route.query,
            //         modal: 'BetDetails',
            //         data: `${this.gameDropValue}:${item._id}`,
            //         isShowShare: 'false',
            //     },
            // });
            this.historyDetail = {
                modal: 'BetDetails',
                data: `${this.gameDropValue}:${item._id}`,
                isShowShare: "false"
            };
            this.historyDetailShow = true;
        },
        /** 特殊游戏处理
         * futuresGame 打开游戏详情弹框
         */
        openGameDetail(data){
            this.historyDetail = data;
            this.historyDetailShow = true;
        },
        handlePrinciple() {
            this.principleVisible = !this.principleVisible;
        },
        handleHide() {
            this.$emit('update:show', false)
        },
        /**
         * 获取当前游戏名称
         */
        getCurrentGame(){
            const route = useRoute();
            const path = route.path
            if(path.includes('/casino/') && getGameName()){
                return getGameName().split('Game')[0]
            }else if(this.gameDropOptions.length){
                return this.gameDropOptions[1].title.replace('Game','').toLowerCase(); 
            }
        },
        /**
         * 游戏详情关闭后
         */
        hideModel(){
            this.historyDetailShow = false
        },
    },
}); 
</script>

<style lang="scss" scoped>
.game-history {
    user-select: none;

    .history-select {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        z-index: 9;
        background-color: #11161e;
        width: 100%;
        padding: 16px 16px 8px;
        background-clip: padding-box; // 右侧躲避滚动条 
        border-right: solid 5px transparent; // 右侧躲避滚动条 
        .drop-down {
            min-width: 128px;
        }
    }

    .table-container {
        container-type: inline-size;
        padding: 79px 16px 0px;
    }

    .history-table {
        container-type: inline-size;

        .table-header {
            background: linear-gradient(180deg, #12161E 15.68%, #171D2B 86.68%);
            border-radius: 8px;
            color: rgba(147, 172, 211, 1);
            line-height: 3;
        }

        .header-th {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        ul {
            li {
                align-items: center;
                border-radius: 8px;
                display: flex;
                height: 50px;
                margin-top: 6px;
                padding-left: 10px;

                .multi-span {
                    align-items: center;
                    background: #2a3546;
                    border-radius: 56px;
                    color: #55657e;
                    display: inline-flex;
                    font-size: 14px;
                    font-weight: 600;
                    height: 20px;
                    letter-spacing: -.28px;
                    line-height: 20px;
                    padding: 0 7px;
                }

                >div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        .item-game {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: none !important;
        }
    }

    .history-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 20px;
        margin-top: 20px;
        :deep(.q-pagination) {
            button {
                background: #545c6c40;
                color: #55657e;
                border-radius: 10px;
                font-size: 14px;
                font-weight: 600;
                height: 35px;
                min-width: 35px !important;
                margin: 0 2px;
            }

            .q-btn--standard {
                background: #2281f6;
                font-size: 15px;
            }
        }
    }
}

.game-history {
    max-height: 100vh !important;
}
</style>
